import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { BsShieldCheck } from "react-icons/bs";
import { BsPeople } from "react-icons/bs";
import { ImStarEmpty } from "react-icons/im";
import { MdOutlineWifiCalling3 } from "react-icons/md";
import HeaderNav from "./common/HeaderNav";
import Footer from "../component/Footer";

function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title =
      "About VIP Number Studio | Trusted Provider of Premium Mobile Numbers Since 2010";
    document
      .querySelector("meta[name='description']")
      .setAttribute(
        "content",
        "Learn about VIP Number Studio, a trusted provider of premium mobile numbers across India since 2010. Discover our commitment to delivering over 10,000 exclusive numbers and our dedication to customer satisfaction."
      );
  }, []);

  return (
    <>
      {/* Header Navigation */}
      <HeaderNav activeTabName="aboutUs" />

      {/* Hero Section with Overlay */}
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "300px",
          overflow: "hidden",
          marginTop: "60px",
        }}
      >
        {/* Background Image */}
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        {/* Gradient Overlay */}
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            background: "#000040",
          }}
        ></div>
        {/* Red circular accent */}
        <div
          style={{
            position: "absolute",
            width: "300px",
            height: "300px",
            backgroundColor: "rgba(255, 0, 0, 0.8)",
            borderRadius: "50%",
            top: "-150px",
            right: "-100px",
            zIndex: 1,
          }}
        ></div>

        {/* Second red circular accent */}
        <div
          style={{
            position: "absolute",
            width: "150px",
            height: "150px",
            backgroundColor: "rgba(255, 0, 0, 0.8)",
            borderRadius: "50%",
            bottom: "-70px",
            left: "50px",
            zIndex: 1,
          }}
        ></div>

        {/* Decorative dots */}
        <div
          style={{
            position: "absolute",
            top: "20px",
            left: "20px",
            display: "flex",
            gap: "5px",
          }}
        >
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
            }}
          ></div>
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
            }}
          ></div>
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
            }}
          ></div>
        </div>

        {/* Decorative triangle */}
        <div
          style={{
            position: "absolute",
            bottom: "15px",
            right: "60px",
            width: 0,
            height: 0,
            borderLeft: "15px solid transparent",
            borderRight: "15px solid transparent",
            borderBottom: "26px solid rgba(255, 255, 255, 0.15)",
            transform: "rotate(45deg)",
          }}
        ></div>

        {/* Content Container */}
        <div
          style={{
            position: "relative",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "0 20px",
            zIndex: "2",
          }}
        >
          <h1
            style={{
              color: "white",
              fontSize: "42px",
              fontWeight: "800",
              marginBottom: "16px",
              textAlign: "center",
              textShadow: "2px 2px 8px rgba(0, 0, 0, 0.6)",
            }}
          >
            About Us
          </h1>

          <p
            style={{
              color: "white",
              fontSize: "18px",
              fontWeight: "400",
              maxWidth: "700px",
              textAlign: "center",
              textShadow: "1px 1px 4px rgba(0, 0, 0, 0.8)",
            }}
          >
            Learn about VIP Number Studio, a trusted provider of premium
          </p>

          {/* Decorative Line */}
          <div
            style={{
              width: "80px",
              height: "4px",
              background:
                "linear-gradient(90deg,rgba(255, 255, 255, 0.74), rgb(233, 2, 2))",
              marginTop: "20px",
              borderRadius: "2px",
            }}
          ></div>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="main-content">
        <div className="container">
          {/* Welcome Section */}
          <div className="welcome-section">
            <h2 className="section-title">
              Welcome to the world of{" "}
              <span className="highlight">VIP Numbers</span>
            </h2>
            <div className="accent-line center"></div>

            <p className="content-text center">
              VIP Number Studio has been a trusted provider of premium mobile
              numbers across India since 2010. Over the years, we have
              successfully delivered 10,000+ exclusive numbers to satisfied
              customers, ensuring a seamless and reliable experience. Whether
              you're looking for a personalized mobile number or a unique,
              high-value VIP number, we offer the best selection at competitive
              prices.
            </p>
            <p className="content-text center">
              Our success is built on long-term relationships with customers,
              including prominent personalities across India, who have chosen us
              for their exclusive number needs.
            </p>
          </div>

          {/* Features Grid */}
          <div className="features-grid">
            <div className="feature-card">
              <BsShieldCheck className="feature-icon" />
              <h3 className="feature-title">Trusted Service</h3>
              <p className="feature-text">
                Over a decade of excellence in providing secure and reliable
                services.
              </p>
            </div>

            <div className="feature-card">
              <BsPeople className="feature-icon" />
              <h3 className="feature-title">10,000+ Numbers Sold</h3>
              <p className="feature-text">
                Many clients have chosen us for their VIP numbers.
              </p>
            </div>

            <div className="feature-card">
              <ImStarEmpty className="feature-icon" />
              <h3 className="feature-title">Exclusive VIP Numbers</h3>
              <p className="feature-text">
                A premium collection of unique and sought-after mobile numbers.
              </p>
            </div>

            <div className="feature-card">
              <MdOutlineWifiCalling3 className="feature-icon" />
              <h3 className="feature-title">Expert Guidance</h3>
              <p className="feature-text">
                A dedicated team to assist you in selecting the perfect number.
              </p>
            </div>
          </div>

          {/* Our Motto Section */}
          <div className="motto-section">
            <h2 className="section-title">OUR MOTTO</h2>
            <div className="accent-line center"></div>

            <h3 className="motto-subtitle">Customer-Centric Service</h3>
            <p className="motto-text">
              Our mission is to provide exceptional service to every customer.
              We have earned our reputation through dedication and trust,
              ensuring that each client receives the highest quality service
              they deserve.
            </p>
          </div>

          {/* Why Choose Us Section */}
          <div className="why-choose-section">
            <h2 className="section-title">WHY CHOOSE VIP NUMBER STUDIO</h2>
            <div className="accent-line center"></div>

            <p className="content-text center">
              As India's largest provider of VIP mobile numbers, we offer an
              extensive range of exclusive numbers at unbeatable prices. Whether
              for personal or business use, our collection ensures that you find
              the perfect number to suit your needs. Now, booking your preferred
              VIP number is easier than ever with MODERN TELECOM SALES AND
              SERVICES.
            </p>

            <div className="cta-container">
              <Link to="/contactUs" className="cta-button">
                Contact Us Today
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default About;
